<template>
  <div id="add-news-trend" class="m-t-10">
    <form action="#">
      <div class="form-group">
        <label for="input-trend">News Trend</label>
        <div class="form-group">
          <multiselect
            v-model="selectNewstrend"
            :options="optionNewstrend"
            placeholder="Pilih News Trend"
            @select="changeNewsTrend"
            label="text"
            track-by="text"
          ></multiselect>
        </div>
      </div>
      <div v-if="isNew" class="form-group">
        <label for="input-judul">Judul</label>
        <div class="form-group">
          <input
            type="text"
            value=""
            id="input-judul"
            class="form-control"
            placeholder="Judul"
            required
            v-model="judul"
          />
        </div>
      </div>
      <div v-if="isNew" class="form-group">
        <label for="input-username">Deskripsi</label>
        <div class="form-group">
          <textarea
            class="form-control"
            id="content"
            name="content"
            rows="15"
            v-model="deskripsi"
          />
        </div>
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button type="button" @click="submitForm" class="btn btn-primary">
          Simpan
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import $ from "jquery";

import Multiselect from "vue-multiselect";
import notif from "@/assets/js/notif.js";
$.pgNotification = notif;
export default {
  name: "modal_add_to_news_trend",
  props: {
    data: Array,
  },
  components: {
    multiselect: Multiselect,
  },
  data() {
    return {
      isNew: false,
      deskripsi: "",
      judul: "",
      id_project: this.$store.getters.user.id_project,
      dataNewsTrend: [],
      optionNewstrend: [],
      tanggalDailyTrend: [],
      selectNewstrend: "",
      idDailyTrend: "",
      id_news_trend: "",
    };
  },
  methods: {
    submitForm: function () {
      if (this.isNew) {
        this.saveNewsTrend();
      } else {
        this.getDailyNewsTrend();
      }
    },
    saveAddStrem: function (id, streams) {
      let params = {
        streams: streams,
        _id: id,
      };
      let api = process.env.VUE_APP_API_URL + "newstrend/save-streams";
      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            if (!this.isNew) {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Trend berhasil disimpan.',
                  position: "top",
                  timeout: 4000,
                  type: "success",
                })
                .show();
            }
          } else if (response.status == 204) {
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> Berita ini sudah ada pada periode ini.',
                position: "top",
                timeout: 4000,
                type: "success",
              })
              .show();
          }
        })
        .catch(() => {
          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Gagal!</b> Terjadi kesalahan, mohon coba lagi.',
              position: "top",
              timeout: 4000,
              type: "danger",
            })
            .show();
        })
        .finally(() => {
          if (this.isNew) {
            this.getDataNewsTrend();
          }
          this.isNew = false;
        });
    },
    saveDailyTrend: function (count, date, parent, streams) {
      let params = {
        count: parseInt(count),
        date: date,
        parent: parent,
      };
      let api = process.env.VUE_APP_API_URL + "newstrend/save-trend";
      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            this.idDailyTrend = response.data.inserted_id.$oid;
          }
        })
        .catch(() => {
          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan pada saat menambahkan news trend!',
              position: "top",
              timeout: 5000,
              type: "danger",
            })
            .show();
        })
        .finally(() => {
          this.saveAddStrem(this.idDailyTrend, streams);
        });
    },
    saveNewsTrend: function () {
      if (this.judul != null) {
        let params = {
          title: this.judul,
          description: this.deskripsi == null ? "-" : this.deskripsi,
          id_project: this.id_project,
        };
        let api = process.env.VUE_APP_API_URL + "newstrend/save";
        this.$http
          .post(api, params)
          .then((response) => {
            if (response.status == 200) {
              this.id_news_trend = response.data.inserted_id.$oid;
              $("#add-news-trend")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-check-circle"></i><b>Berhasil!</b> News Trend berhasil disimpan.',
                  position: "top",
                  timeout: 2000,
                  type: "success",
                })
                .show();
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.judul = "";
            this.deskripsi = "";
            this.getDailyNewsTrend();
          });
      } else {
        alert("pastikan semua field terisi");
      }
    },
    changeNewsTrend: function (value) {
      if (value.text == "Tambah News Trend") {
        this.isNew = true;
      } else {
        this.isNew = false;
      }
      this.selectNewstrend = value.id;
    },
    getDataNewsTrend: function () {
      let api =
        process.env.VUE_APP_API_URL + "newstrend/list/" + this.id_project;
      this.$http.get(api).then((response) => {
        if (response.status == 200) {
          this.dataNewsTrend = response.data;
          this.optionNewstrend = [];
          for (let key in this.dataNewsTrend) {
            this.optionNewstrend.push({
              text: this.dataNewsTrend[key].title,
              id: this.dataNewsTrend[key]._id.$oid,
            });
          }
          this.optionNewstrend.push({
            text: "Tambah News Trend",
            id: "",
          });
        }
      });
    },
    getDailyNewsTrend: function () {
      let param = this.isNew ? this.id_news_trend : this.selectNewstrend.id;
      let api = process.env.VUE_APP_API_URL + "newstrend/detail/" + param;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 204) {
            this.dataNewsTrend = {};
          } else if (response.status == 200) {
            this.tanggalDailyTrend = response.data.trend;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          for (let key in this.data) {
            let index = this.tanggalDailyTrend.findIndex(
              (element) => element.date == this.data[key].tanggal
            );
            if (index != -1) {
              this.saveAddStrem(
                this.tanggalDailyTrend[key]._id.$oid,
                this.data[key].streams
              );
            } else {
              this.saveDailyTrend(
                this.data[key].streams.length,
                this.data[key].tanggal,
                this.isNew ? this.id_news_trend : this.selectNewstrend.id,
                this.data[key].streams
              );
            }
          }
          if (!this.isNew) {
            $("#modal-edit-stream").modal("hide");
          }
        });
    },
  },
  mounted: function () {
    this.getDataNewsTrend();
  },
};
</script>
